export default __webpack_public_path__ + "static/media/Crossing-Red-24x24.a7225f5f.svg";